import { createContext, useContext } from 'react';

import type { CellAlignY } from './types';

export type TableRowContextType = {
  /**
   * Sets the vertical alignment for content within each cell.
   * @default 'center'
   */
  alignY?: CellAlignY;
};

export const TableRowContext = createContext<TableRowContextType>({
  alignY: 'center',
});

export function useTableRowContext() {
  const ctx = useContext(TableRowContext);

  if (!ctx) {
    throw new Error(
      'Table rows must be rendered within a `Table` ancestor to access context.'
    );
  }

  return useContext(TableRowContext);
}
